import { entryList, updateLog } from "@/mocks/homeData";

export default function EntrySection() {
  return (
    <section id="entries" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
          <div>
            <span className="text-xs font-medium tracking-wide text-accent-600">入口速查</span>
            <h2 className="mt-2 font-heading font-bold text-xl md:text-3xl text-foreground-950">
              最新可用入口一览
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-2xl">
              下列线路按更新时间排列，状态与延迟会随巡检同步。选择标注「运行中」的入口即可访问。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-refresh-line text-base text-accent-500"></i>
            最近同步：10 分钟前
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="lg:col-span-2 flex flex-col gap-3">
            {entryList.map((entry) => {
              const running = entry.status === "运行中";
              return (
                <a
                  key={entry.id}
                  href="#entries"
                  className="group bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 px-4 py-4 flex items-start justify-between gap-4 transition-colors cursor-pointer"
                >
                  <div className="flex items-start gap-3 min-w-0">
                    <span
                      className={`mt-0.5 w-8 h-8 rounded-md flex items-center justify-center shrink-0 ${
                        running
                          ? "bg-accent-100 text-accent-700"
                          : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      <i className={running ? "ri-link" : "ri-tools-line"}></i>
                    </span>
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <h4 className="font-medium text-sm text-foreground-950">{entry.name}</h4>
                        <span
                          className={`px-2 py-0.5 rounded-full text-[11px] ${
                            running
                              ? "bg-accent-500/15 text-accent-700"
                              : "bg-secondary-500/15 text-secondary-900"
                          }`}
                        >
                          {entry.status}
                        </span>
                        <span className="px-2 py-0.5 rounded-full text-[11px] bg-background-100 text-foreground-600">
                          {entry.latency}
                        </span>
                      </div>
                      <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 line-clamp-2">
                        {entry.summary}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-1 shrink-0">
                    <span className="text-[11px] text-foreground-400">{entry.updated}</span>
                    <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
                  </div>
                </a>
              );
            })}
          </div>

          <aside className="flex flex-col gap-5">
            <div className="bg-background-50 rounded-lg border border-background-200 p-4">
              <h3 className="font-heading font-semibold text-base text-foreground-950 flex items-center gap-2">
                <i className="ri-history-line text-primary-500"></i>
                线路更新动态
              </h3>
              <ul className="mt-4 flex flex-col gap-4">
                {updateLog.map((log, i) => (
                  <li key={log.id} className="flex gap-3">
                    <div className="flex flex-col items-center pt-1">
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                      {i < updateLog.length - 1 && (
                        <span className="flex-1 w-px bg-background-300 mt-1"></span>
                      )}
                    </div>
                    <div className="pb-1">
                      <p className="text-xs leading-relaxed text-foreground-700">{log.text}</p>
                      <span className="text-[11px] text-foreground-400">{log.time}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-secondary-500 rounded-lg p-4 text-background-50 dark:text-foreground-950">
              <h3 className="font-heading font-semibold text-base">还没解决？</h3>
              <p className="mt-2 text-xs leading-relaxed opacity-90">
                若常用入口打不开，多半是线路维护或本地网络限制，先按下方步骤排查，再回到本页换线路。
              </p>
              <a
                href="#troubleshoot"
                className="mt-4 inline-flex items-center gap-2 px-3 py-2 rounded-md bg-background-50 text-secondary-900 text-xs font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                前往排查步骤
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}